import { useQuery } from '@tanstack/react-query';

import { analyticsService } from './analytics.services';

import type { AnalyticsSummary } from './analytics.types';

/**
 * Query Key Factory for the Analytics domain.
 */
export const analyticsQueryKeys = {
  all: ['analytics'] as const,
  summary: () => [...analyticsQueryKeys.all, 'summary'] as const,
};

/**
 * Returns the analytics summary for the current period from the real API.
 * Endpoint: GET /admin/analytics
 */
export const useGetAnalyticsSummary = () => {
  return useQuery({
    queryKey: analyticsQueryKeys.summary(),
    queryFn: (): Promise<AnalyticsSummary> => analyticsService.getSummary(),
  });
};
